import { Middleware, Dispatch } from 'redux';
import { IApplicationState } from './applicationState';
import { updateUserPromise } from '../services/api';

const accessTokenChangeMiddleware: Middleware<{}, IApplicationState> = api => (next: Dispatch) => action => {
    const previousState = api.getState();
    const result = next(action);
    const resultState = api.getState();

    if (resultState.oidc && 
        previousState.oidc && 
        resultState.oidc.user && 
        previousState.oidc.user && 
        resultState.oidc.user.access_token !== previousState.oidc.user.access_token) {
            updateUserPromise();
    }

    return result;
}

export default accessTokenChangeMiddleware;